/* eslint-disable react/require-default-props */
// TODO: deprecated — migrate usages to B2ChatAlertDialog from '@src/components/UI/B2ChatAlertDialog'
import {
  Box,
  Button,
  Dialog as Popup,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';
import './alert.css';

// eslint-disable-next-line no-shadow
export const enum ButtonPosition {
  center,
  right,
  left,
}

type TDialogProps = {
  show: boolean;
  showIcon: boolean;
  title: string;
  handleClick: (actionClick: ButtonPosition) => void;
  children?: React.ReactNode;
  centerButton?: string | null;
  rightButton?: string;
  leftButton?: string;
  icon?: React.ReactNode;
  disableRightBtn: boolean;
};

const Dialog = ({
  centerButton = null,
  rightButton,
  leftButton,
  show,
  showIcon = false,
  title,
  children,
  handleClick,
  icon,
  disableRightBtn = false,
}: TDialogProps) => {
  const justifyContent = centerButton ? 'center' : 'space-between';
  return (
    <Popup open={show}>
      <DialogTitle>
        <Box display="flex" justifyContent="center">
          {title}
        </Box>
        {showIcon && (
          <Box display="flex" justifyContent="center" mt={1}>
            {icon}
          </Box>
        )}
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" flexDirection="column">
          {children}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box width="100%" display="flex" justifyContent={justifyContent}>
          {centerButton ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClick(ButtonPosition.center)}
            >
              {centerButton}
            </Button>
          ) : (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleClick(ButtonPosition.left)}
              >
                {leftButton}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={disableRightBtn}
                onClick={() => handleClick(ButtonPosition.right)}
              >
                {rightButton}
              </Button>
            </>
          )}
        </Box>
      </DialogActions>
    </Popup>
  );
};

export default Dialog;
